import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';

/**
 * @typedef {Object} ActionItem
 * @property {string} name    Modal name to dispatch.
 * @property {string} label   Human-visible dropdown label.
 * @property {Object} payload Data forwarded to `setActiveElement`.
 *
 * @typedef {Object} BuildActionItemsArgs
 * @property {string[]} [allow]                Ordered subset of modal names to include.
 * @property {Record<string, Object>} [payloads] Per-modal payload overrides.
 */

// Default labels for each modal action (move to a shared const if you prefer)
export const ACTION_LABELS = {
	[MODAL_NAMES.traveling]: 'Travel to location',
	[MODAL_NAMES.protection]: 'Set on protection',
	[MODAL_NAMES.holdDown]: 'Add Hold down',
	[MODAL_NAMES.absence]: 'Schedule absence',
	[MODAL_NAMES.employmentType]: 'Add employment change',
	[MODAL_NAMES.updateCrewLocation]: 'Update crew member’s location',
};

export const DEFAULT_ACTION_ORDER = Object.keys(ACTION_LABELS);

/**
 * @param {BuildActionItemsArgs} [args]
 * @returns {ActionItem[]}
 */
export function buildActionItems({ allow = DEFAULT_ACTION_ORDER, payloads = {} } = {}) {
	return DEFAULT_ACTION_ORDER.filter((name) => allow.includes(name)).map((name) => ({
		name,
		label: ACTION_LABELS[name],
		payload: payloads[name] || {},
	}));
}
